var GMap, GMapMarkers, GMapView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

GMap = window.GMap != null ? window.GMap : window.GMap = {};

if (GMap.vent == null) {
  GMap.vent = require('../../frontend/helpers/events');
}

GMapMarkers = require('../markers');

GMapView = (function(superClass) {
  extend(GMapView, superClass);

  function GMapView() {
    return GMapView.__super__.constructor.apply(this, arguments);
  }

  GMapView.prototype.events = {
    'click .merchant-location-card, a': function() {
      return stopClickPropagation(event);
    },
    'click .static-map': 'changeToDynamic'
  };

  GMapView.prototype.Markers = GMapMarkers;

  GMapView.prototype.initialize = function() {
    var $body, ref;
    ref = this.options, this.mapOptions = ref.mapOptions, this.markerData = ref.markerData, this.staticMaps = ref.staticMaps, this.userMarkerData = ref.userMarkerData, this.isDesktop2016V2 = ref.isDesktop2016V2;
    $body = $(document.body);
    this.$locationsModal = $('#locations');
    this.$staticMap = this.$el.find('.static-map').add(this.$locationsModal.find('static-map'));
    this.$dynamicMap = this.$el.find('.dynamic-map').add(this.$locationsModal.find('dynamic-map'));
    GMap.vent.on('start', (function(_this) {
      return function() {
        return _this.start();
      };
    })(this));
    this.isLocationsPopupWasActivated = false;
    this.isDynamicMapsWasActivated = false;
    return $body.on("modal-open:locations", (function(_this) {
      return function() {
        return _this.onLocationsPopupOpen();
      };
    })(this));
  };

  GMapView.prototype.stopClickPropagation = function(event) {
    return event.stopPropagation();
  };

  GMapView.prototype.changeToDynamic = function() {
    Groupon.Utils.GoogleMaps.load(function(err) {
      if (err != null) {
        return;
      }
      return GMap.vent.trigger('start');
    });
    return false;
  };

  GMapView.prototype.shouldShowLocationsModal = function() {
    return this.$locationsModal.hasClass('show-modal');
  };

  GMapView.prototype.start = function() {
    var showLocationsModal;
    if (this.googleMaps == null) {
      this.googleMaps = window.google.maps;
    }
    showLocationsModal = this.shouldShowLocationsModal();
    if (!showLocationsModal) {
      this.$locationsModal.css({
        display: 'block',
        visibility: 'hidden'
      });
    }
    this.createDynamicMap(this.mapOptions);
    if (this.activeMap) {
      this.markerHandler = new this.Markers(this.googleMaps);
      this.markerHandler.makeMarkers(this.markerData);
      this.markerHandler.addMarkersToMap(this.activeMap);
      this.revealDynamicMap(showLocationsModal);
      if (!showLocationsModal) {
        this.$locationsModal.css({
          display: '',
          visibility: ''
        });
      }
      return this.isDynamicMapsWasActivated = true;
    }
  };

  GMapView.prototype.createDynamicMap = function(options) {
    var mapOptions;
    mapOptions = this.buildMapOptions(options);
    return this.activeMap = new this.googleMaps.Map(this.$dynamicMap[0], mapOptions);
  };

  GMapView.prototype.revealDynamicMap = function() {
    if (this.$dynamicMap == null) {
      return;
    }
    this.$dynamicMap.each(function() {
      var $dynamicMap, $mapLocationCards, $staticMap, cardsContainer;
      $dynamicMap = $(this);
      $staticMap = $dynamicMap.siblings('.static-map');
      cardsContainer = $staticMap.find('.merchant-cards-container');
      if (cardsContainer) {
        $mapLocationCards = cardsContainer;
      } else {
        $mapLocationCards = $staticMap.find('.merchant-location-cards');
      }
      if ($staticMap.length) {
        $dynamicMap.css({
          height: $staticMap.height(),
          width: $staticMap.width()
        });
      }
      if ($mapLocationCards.length) {
        return $mapLocationCards.appendTo($dynamicMap);
      }
    });
    this.$staticMap.off('click');
    this.$staticMap.hide();
    return this.$dynamicMap.show();
  };

  GMapView.prototype.buildMapOptions = function(mapOptions) {
    mapOptions.center = new this.googleMaps.LatLng(mapOptions.center.lat, mapOptions.center.lng);
    mapOptions.mapTypeId = this.googleMaps.MapTypeId.ROADMAP;
    return mapOptions;
  };

  GMapView.prototype.onLocationsPopupOpen = function() {
    if (!this.isLocationsPopupWasActivated && this.isDynamicMapsWasActivated) {
      this.isLocationsPopupWasActivated = true;
      GMap.vent.once('start', (function(_this) {
        return function() {
          return _this.start();
        };
      })(this));
      return this.changeToDynamic();
    }
  };

  return GMapView;

})(Backbone.View);

module.exports = GMapView;

//# sourceMappingURL=data:application/json;base64,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
